import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as Constants from '../actions/explorer/ActionConstants';
import {
  initializeNodesFailed,
  initializeNodesSuccess,
  initializeRepositoriesFailed,
  initializeRepositoriesSuccess
} from '../actions/explorer/Actions';
import { InitializeNodes } from '../actions/explorer/ActionTypes';
import { getChildrenNodes, getRepositories } from '../api/Explorer';

function* getRepositoriesSaga() {
  try {
    const repos = yield call(getRepositories);
    yield put(initializeRepositoriesSuccess(repos));
  } catch (error) {
    yield put(initializeRepositoriesFailed());
  }
}

function* watchForGetRepositories() {
  yield takeLatest(Constants.INITIALIZE_REPOSITORIES, getRepositoriesSaga);
}

function* getNodesSaga(action: InitializeNodes) {
  try {
    let nodes = yield call(getChildrenNodes, action.payload.parentId);
    if (nodes === '') {
      nodes = [];
    }
    yield put(initializeNodesSuccess(nodes));
  } catch (error) {
    yield put(initializeNodesFailed());
  }
}

function* watchForGetNodes() {
  yield takeLatest(Constants.INITIALIZE_NODES, getNodesSaga);
}

export default function* schemaExplorerSaga() {
  yield all([watchForGetRepositories(), watchForGetNodes()]);
}
